/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import styles from './carbon-toolkit.scss';

import CodeSnippet from './components/CodeSnippet';

export const prefix = styles.prefix.replace(/"/g, '');

// re-export carbon components for now, in the future we can wrap the ones we need to for translation, data-tids, bidi or add non-exisiting functionality
export * from 'carbon-components-react';
export { CodeSnippet };
